import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading; null = not authed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 代理ログイン: 新しいタブで起動時に sessionStorage の払い出しを受け取る
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get("impersonate") === "1") {
        const raw = sessionStorage.getItem("impersonate_payload");
        if (raw) {
          const payload = JSON.parse(raw);
          sessionStorage.removeItem("impersonate_payload");
          // このタブのみ独立した sessionStorage に格納
          sessionStorage.setItem("shift_token", payload.token);
          sessionStorage.setItem("shift_user", JSON.stringify(payload.user));
          sessionStorage.setItem("impersonated_by", payload.impersonated_by || "admin");
          // クエリパラメータをクリア
          window.history.replaceState({}, "", window.location.pathname);
        }
      }
    } catch { /* ignore */ }

    // セッショントークン優先（代理ログインタブ）→ なければ localStorage（通常）
    const token = sessionStorage.getItem("shift_token") || localStorage.getItem("shift_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        sessionStorage.removeItem("shift_token");
        sessionStorage.removeItem("shift_user");
        localStorage.removeItem("shift_token");
        localStorage.removeItem("shift_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (login_id, password, tenant_slug) => {
    const body = { login_id, password };
    if (tenant_slug) body.tenant_slug = tenant_slug;
    const { data } = await api.post("/auth/login", body);
    localStorage.setItem("shift_token", data.access_token);
    localStorage.setItem("shift_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const loginManager = async (login_id, email, password) => {
    const { data } = await api.post("/auth/login", { login_id, email, password });
    localStorage.setItem("shift_token", data.access_token);
    localStorage.setItem("shift_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const loginStaff = async (tenant_login_id, login_id, password) => {
    const { data } = await api.post("/auth/login", { tenant_login_id, login_id, password });
    localStorage.setItem("shift_token", data.access_token);
    localStorage.setItem("shift_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    const slug = user?.tenant_slug;
    localStorage.removeItem("shift_token");
    localStorage.removeItem("shift_user");
    setUser(null);
    window.location.href = slug ? `/${slug}/login` : "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginManager, loginStaff, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
